import * as React from 'react';
import { Button, IconFolder16 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export function FolderButton(_ref) {
  var foldersCount = _ref.foldersCount,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    size: "XS",
    beforeIcon: /*#__PURE__*/_jsx(IconFolder16, {}),
    theme: "fill_secondary",
    children: foldersCount
  });
}